import SelectionMenu from './SelectionMenu';

export default SelectionMenu;
